import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

import { breakpointDown } from '/shared/styled/Breakpoints';

export default function smallStyle({ $small, $smallMobile, $secondary }: ButtonStyleProps) {
  if ($smallMobile) {
    return css`
      ${breakpointDown('mobile')} {
        font-size: 0.8rem;
      }
    `;
  }
  if ($small && $secondary) {
    return css`
      font-size: 13px;
      `;
  }

  if ($small && !$secondary) {
    return css`
      min-height: 0;
      font-size: 0.8rem;
      padding: 10px 15px;
    `;
  }
}
